import { Component, OnInit } from '@angular/core';
import { SetupEquipmentService } from '../../../../modules/setup-equipment/setup-equipment.service';
import { CustomerSelectItem } from '../../../../../app/modules/setup-equipment/setup-equipment.model';
import { FrontEndComponetService } from '../front-end-componet.service';
import { GenericIdName } from '../../setup-implement/setup-implement.model';
import { CurrentSelection } from '../../entities/global/model';
import { FECRAdditionalObsVM, ImplementSelectItem } from '../FECRDashboard/fecr-search-panel/fecr-search-panel.model';
import { NewObservationListPropertyComponent } from '../../../inspection/add-inspection-observation-lists/new-observation-list-property/new-observation-list-property.component';
import { MatDialog } from '@angular/material/dialog';import { FecrAddNewPrepostShipmentObservationComponent } from '../fecr-add-new-prepost-shipment-observation/fecr-add-new-prepost-shipment-observation.component';
import { AppService } from '../../../..//app.service';

@Component({
  selector: 'app-fecr-pre-post-shipment-observation-list',
  templateUrl: './fecr-pre-post-shipment-observation-list.component.html',
  styleUrls: ['./fecr-pre-post-shipment-observation-list.component.scss']
})
export class FecrPrePostShipmentObservationListComponent implements OnInit {
  customerList:CustomerSelectItem[]=[];
  implementTypeList: ImplementSelectItem[] = [];
  copyimplementTypeList: ImplementSelectItem[] = [];
  selectedInspectionType:number=0;
selected :boolean=false;
  // PreShipmenet:boolean=false;
  // PostShipment:boolean=false;
  // ArrivalRepair:boolean=false;


  _currentSelection: CurrentSelection = new CurrentSelection();
  selectedCustomerId:number;
  selectedImplmentTypeId:number;
  ImplementTypeLevelObservationList:FECRAdditionalObsVM[];
  constructor(
    private _equipmentService: SetupEquipmentService,
    private _fecrService: FrontEndComponetService,
    private _dialog: MatDialog,private _appService: AppService,
  ) { }

  ngOnInit() {
    this._appService.setPageTitle('Manage Pre-Post Shipment Observation');
    this._equipmentService.getCustomerList().subscribe(result => { this.customerList = result;  }, error => { console.error(error); }, () => {  });
    this.loadImplementTypes();
  }

  loadImplementTypes() {

    this._fecrService.getImplementTypeList().subscribe(r => {
      this.copyimplementTypeList =r;
    });
  }

  ChangeCustomer(){
    this.selected =false;
    console.log("implliets,", this.implementTypeList, this.selectedCustomerId)
    if(this.selectedCustomerId>0 && this.selectedCustomerId!=null){

      this.implementTypeList =this.copyimplementTypeList.filter(x=>x.CustomerId == this.selectedCustomerId || x.CustomerId==null)
      console.log("implliets,", this.implementTypeList, this.selectedCustomerId)
      
    }
  }

  ChangeImplmentType(){
    if(this.selectedImplmentTypeId>0){
      this.selected=true
      this.loadImplementTypeAddtionalObservationList();
    }
   
    else{
      this.selected =false;
    }
  }

  addNewObservationListOnCustomer() {

    const dialogRef = this._dialog.open(FecrAddNewPrepostShipmentObservationComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        //selectedCustomer: this.selectedCustomer
        isEditing:false,
        ImplementTypeId:this.selectedImplmentTypeId
      }
    });

    dialogRef.afterClosed().subscribe(addedCustomer => {
      if (addedCustomer) {
        this.loadImplementTypeAddtionalObservationList();
      }
    });
   }

   loadImplementTypeAddtionalObservationList(){
     this._fecrService.GETFECRAdditionalObservationForInspectionType(this.selectedImplmentTypeId,this.selectedInspectionType).subscribe(res=>{
      this.ImplementTypeLevelObservationList = res;
     })
   }

   editObservation(model:FECRAdditionalObsVM){
    const dialogRef = this._dialog.open(FecrAddNewPrepostShipmentObservationComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        //selectedCustomer: this.selectedCustomer
        isEditing:true,
        Title:model.Title,
        ImplementTypeId:model.ImplementTypeId,
        InspectionTypeId:model.InspectionTypeId,
        Id:model.Id,
        Active:model.Active,


      }
    });

    dialogRef.afterClosed().subscribe(addedCustomer => {
      if (addedCustomer) {
        this.loadImplementTypeAddtionalObservationList();
      }
    });
   }

  

}
